<app-local-load-status [status]="event.oldValue"></app-local-load-status>

<span class="load-event-values-separator">
    <i class="fa fa-arrow-right"></i>
</span>

<app-local-load-status [status]="event.newValue"></app-local-load-status>
